import { defineMessages } from 'react-intl'

export default defineMessages({
    advanceRestriction: {
        defaultMessage: 'Reserva con {duration} de antelación',
    },
    minStayRestriction: {
        defaultMessage: 'Reserva mínima {duration}',
    },
    maxStayRestriction: {
        defaultMessage: 'Reserva máxima {duration}',
    },
})
